/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
import './models';
import '../../../connect/v2/resources/error';
import '../activities/models';
import '../../api/v1/settlement/models';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "capital": {
        "nested": {
          "servicing": {
            "nested": {
              "plan": {
                "nested": {
                  "service": {
                    "nested": {
                      "ListPlansRequest": {
                        "fields": {
                          "statuses": {
                            "type": ".squareup.capital.servicing.plan.models.Plan.Status",
                            "id": 1,
                            "rule": "repeated"
                          },
                          "customerTokens": {
                            "type": "string",
                            "id": 2,
                            "rule": "repeated"
                          }
                        }
                      },
                      "ListPlansResponse": {
                        "fields": {
                          "plans": {
                            "type": ".squareup.capital.servicing.plan.models.Plan",
                            "id": 1,
                            "rule": "repeated"
                          },
                          "cursor": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "errors": {
                            "type": ".squareup.connect.v2.resources.Error",
                            "id": 3,
                            "rule": "repeated"
                          }
                        }
                      },
                      "RetrievePlanRequest": {
                        "fields": {
                          "id": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          }
                        }
                      },
                      "RetrievePlanResponse": {
                        "fields": {
                          "plan": {
                            "type": ".squareup.capital.servicing.plan.models.Plan",
                            "id": 1,
                            "rule": "optional"
                          },
                          "errors": {
                            "type": ".squareup.connect.v2.resources.Error",
                            "id": 2,
                            "rule": "repeated"
                          }
                        }
                      },
                      "CancelScheduledPaymentRequest": {
                        "fields": {
                          "id": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "reason": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "actorUid": {
                            "type": "int32",
                            "id": 3,
                            "rule": "optional"
                          }
                        }
                      },
                      "CancelScheduledPaymentResponse": {
                        "fields": {
                          "status": {
                            "type": ".squareup.capital.servicing.plan.models.ScheduledPayment.Status",
                            "id": 1,
                            "rule": "optional"
                          },
                          "errors": {
                            "type": ".squareup.connect.v2.resources.Error",
                            "id": 2,
                            "rule": "repeated"
                          }
                        }
                      },
                      "CancelPlanRequest": {
                        "fields": {
                          "id": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "reason": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "actorUid": {
                            "type": "int32",
                            "id": 3,
                            "rule": "optional"
                          }
                        }
                      },
                      "CancelPlanResponse": {
                        "fields": {
                          "plan": {
                            "type": ".squareup.capital.servicing.plan.models.Plan",
                            "id": 1,
                            "rule": "optional"
                          },
                          "errors": {
                            "type": ".squareup.connect.v2.resources.Error",
                            "id": 2,
                            "rule": "repeated"
                          }
                        }
                      },
                      "ListPlanActivitiesRequest": {
                        "fields": {
                          "id": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          }
                        }
                      },
                      "ListPlanActivitiesResponse": {
                        "fields": {
                          "activities": {
                            "type": ".squareup.capital.servicing.activities.models.Activity",
                            "id": 1,
                            "rule": "repeated"
                          },
                          "cursor": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "errors": {
                            "type": ".squareup.connect.v2.resources.Error",
                            "id": 3,
                            "rule": "repeated"
                          }
                        }
                      },
                      "RetrievePlanEligibilityRequest": {
                        "fields": {
                          "planToken": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          }
                        }
                      },
                      "RetrievePlanEligibilityResponse": {
                        "fields": {
                          "planEligibility": {
                            "type": ".squareup.capital.servicing.plan.models.PlanEligibility",
                            "id": 1,
                            "rule": "optional"
                          },
                          "errors": {
                            "type": ".squareup.connect.v2.resources.Error",
                            "id": 2,
                            "rule": "repeated"
                          }
                        }
                      },
                      "GetPlanOriginationStatusRequest": {
                        "fields": {
                          "planToken": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          }
                        }
                      },
                      "GetPlanOriginationStatusResponse": {
                        "fields": {
                          "status": {
                            "type": ".squareup.capital.api.v1.settlement.models.Status",
                            "id": 1,
                            "rule": "optional"
                          },
                          "errors": {
                            "type": ".squareup.connect.v2.resources.Error",
                            "id": 2,
                            "rule": "repeated"
                          }
                        }
                      },
                      "GetPlanLinkedBankAccountRequest": {
                        "fields": {
                          "planToken": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          }
                        }
                      },
                      "GetPlanLinkedBankAccountResponse": {
                        "fields": {
                          "accountToken": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "errors": {
                            "type": ".squareup.connect.v2.resources.Error",
                            "id": 2,
                            "rule": "repeated"
                          }
                        }
                      },
                      "PlanService": {
                        "methods": {
                          "ListPlans": {
                            "requestType": ".squareup.capital.servicing.plan.service.ListPlansRequest",
                            "responseType": ".squareup.capital.servicing.plan.service.ListPlansResponse"
                          },
                          "RetrievePlan": {
                            "requestType": ".squareup.capital.servicing.plan.service.RetrievePlanRequest",
                            "responseType": ".squareup.capital.servicing.plan.service.RetrievePlanResponse"
                          },
                          "CancelPlan": {
                            "requestType": ".squareup.capital.servicing.plan.service.CancelPlanRequest",
                            "responseType": ".squareup.capital.servicing.plan.service.CancelPlanResponse"
                          },
                          "CancelScheduledPayment": {
                            "requestType": ".squareup.capital.servicing.plan.service.CancelScheduledPaymentRequest",
                            "responseType": ".squareup.capital.servicing.plan.service.CancelScheduledPaymentResponse"
                          },
                          "ListPlanActivities": {
                            "requestType": ".squareup.capital.servicing.plan.service.ListPlanActivitiesRequest",
                            "responseType": ".squareup.capital.servicing.plan.service.ListPlanActivitiesResponse"
                          },
                          "RetrievePlanEligibility": {
                            "requestType": ".squareup.capital.servicing.plan.service.RetrievePlanEligibilityRequest",
                            "responseType": ".squareup.capital.servicing.plan.service.RetrievePlanEligibilityResponse"
                          },
                          "GetPlanOriginationStatus": {
                            "requestType": ".squareup.capital.servicing.plan.service.GetPlanOriginationStatusRequest",
                            "responseType": ".squareup.capital.servicing.plan.service.GetPlanOriginationStatusResponse"
                          },
                          "GetPlanLinkedBankAccount": {
                            "requestType": ".squareup.capital.servicing.plan.service.GetPlanLinkedBankAccountRequest",
                            "responseType": ".squareup.capital.servicing.plan.service.GetPlanLinkedBankAccountResponse"
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.capital?.nested?.servicing?.nested?.plan?.nested?.service?.nested?.ListPlansRequest && !$root.nested?.squareup?.nested?.capital?.nested?.servicing?.nested?.plan?.nested?.service?.nested?.ListPlansResponse && !$root.nested?.squareup?.nested?.capital?.nested?.servicing?.nested?.plan?.nested?.service?.nested?.RetrievePlanRequest && !$root.nested?.squareup?.nested?.capital?.nested?.servicing?.nested?.plan?.nested?.service?.nested?.RetrievePlanResponse && !$root.nested?.squareup?.nested?.capital?.nested?.servicing?.nested?.plan?.nested?.service?.nested?.CancelScheduledPaymentRequest && !$root.nested?.squareup?.nested?.capital?.nested?.servicing?.nested?.plan?.nested?.service?.nested?.CancelScheduledPaymentResponse && !$root.nested?.squareup?.nested?.capital?.nested?.servicing?.nested?.plan?.nested?.service?.nested?.CancelPlanRequest && !$root.nested?.squareup?.nested?.capital?.nested?.servicing?.nested?.plan?.nested?.service?.nested?.CancelPlanResponse && !$root.nested?.squareup?.nested?.capital?.nested?.servicing?.nested?.plan?.nested?.service?.nested?.ListPlanActivitiesRequest && !$root.nested?.squareup?.nested?.capital?.nested?.servicing?.nested?.plan?.nested?.service?.nested?.ListPlanActivitiesResponse && !$root.nested?.squareup?.nested?.capital?.nested?.servicing?.nested?.plan?.nested?.service?.nested?.RetrievePlanEligibilityRequest && !$root.nested?.squareup?.nested?.capital?.nested?.servicing?.nested?.plan?.nested?.service?.nested?.RetrievePlanEligibilityResponse && !$root.nested?.squareup?.nested?.capital?.nested?.servicing?.nested?.plan?.nested?.service?.nested?.GetPlanOriginationStatusRequest && !$root.nested?.squareup?.nested?.capital?.nested?.servicing?.nested?.plan?.nested?.service?.nested?.GetPlanOriginationStatusResponse && !$root.nested?.squareup?.nested?.capital?.nested?.servicing?.nested?.plan?.nested?.service?.nested?.GetPlanLinkedBankAccountRequest && !$root.nested?.squareup?.nested?.capital?.nested?.servicing?.nested?.plan?.nested?.service?.nested?.GetPlanLinkedBankAccountResponse && !$root.nested?.squareup?.nested?.capital?.nested?.servicing?.nested?.plan?.nested?.service?.nested?.PlanService) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE ListPlansRequest @ squareup/capital/servicing/plan/service.proto at 56:1
 */
export const ListPlansRequest = $root.lookupType('squareup.capital.servicing.plan.service.ListPlansRequest');
fixType(ListPlansRequest);
Builder.createAndAttachToType(ListPlansRequest);
/**
 * SOURCE ListPlansResponse @ squareup/capital/servicing/plan/service.proto at 64:1
 */
export const ListPlansResponse = $root.lookupType('squareup.capital.servicing.plan.service.ListPlansResponse');
fixType(ListPlansResponse);
Builder.createAndAttachToType(ListPlansResponse);
/**
 * SOURCE RetrievePlanRequest @ squareup/capital/servicing/plan/service.proto at 71:1
 */
export const RetrievePlanRequest = $root.lookupType('squareup.capital.servicing.plan.service.RetrievePlanRequest');
fixType(RetrievePlanRequest, {
  id: {
    required: true
  }
});
Builder.createAndAttachToType(RetrievePlanRequest);
/**
 * SOURCE RetrievePlanResponse @ squareup/capital/servicing/plan/service.proto at 76:1
 */
export const RetrievePlanResponse = $root.lookupType('squareup.capital.servicing.plan.service.RetrievePlanResponse');
fixType(RetrievePlanResponse);
Builder.createAndAttachToType(RetrievePlanResponse);
/**
 * SOURCE CancelScheduledPaymentRequest @ squareup/capital/servicing/plan/service.proto at 82:1
 */
export const CancelScheduledPaymentRequest = $root.lookupType('squareup.capital.servicing.plan.service.CancelScheduledPaymentRequest');
fixType(CancelScheduledPaymentRequest, {
  id: {
    required: true
  }
});
Builder.createAndAttachToType(CancelScheduledPaymentRequest);
/**
 * SOURCE CancelScheduledPaymentResponse @ squareup/capital/servicing/plan/service.proto at 93:1
 */
export const CancelScheduledPaymentResponse = $root.lookupType('squareup.capital.servicing.plan.service.CancelScheduledPaymentResponse');
fixType(CancelScheduledPaymentResponse);
Builder.createAndAttachToType(CancelScheduledPaymentResponse);
/**
 * Q2
 *
 * SOURCE CancelPlanRequest @ squareup/capital/servicing/plan/service.proto at 101:1
 */
export const CancelPlanRequest = $root.lookupType('squareup.capital.servicing.plan.service.CancelPlanRequest');
fixType(CancelPlanRequest, {
  id: {
    required: true
  }
});
Builder.createAndAttachToType(CancelPlanRequest);
/**
 * SOURCE CancelPlanResponse @ squareup/capital/servicing/plan/service.proto at 112:1
 */
export const CancelPlanResponse = $root.lookupType('squareup.capital.servicing.plan.service.CancelPlanResponse');
fixType(CancelPlanResponse);
Builder.createAndAttachToType(CancelPlanResponse);
/**
 * SOURCE ListPlanActivitiesRequest @ squareup/capital/servicing/plan/service.proto at 118:1
 */
export const ListPlanActivitiesRequest = $root.lookupType('squareup.capital.servicing.plan.service.ListPlanActivitiesRequest');
fixType(ListPlanActivitiesRequest);
Builder.createAndAttachToType(ListPlanActivitiesRequest);
/**
 * SOURCE ListPlanActivitiesResponse @ squareup/capital/servicing/plan/service.proto at 123:1
 */
export const ListPlanActivitiesResponse = $root.lookupType('squareup.capital.servicing.plan.service.ListPlanActivitiesResponse');
fixType(ListPlanActivitiesResponse);
Builder.createAndAttachToType(ListPlanActivitiesResponse);
/**
 * SOURCE RetrievePlanEligibilityRequest @ squareup/capital/servicing/plan/service.proto at 129:1
 */
export const RetrievePlanEligibilityRequest = $root.lookupType('squareup.capital.servicing.plan.service.RetrievePlanEligibilityRequest');
fixType(RetrievePlanEligibilityRequest, {
  planToken: {
    required: true
  }
});
Builder.createAndAttachToType(RetrievePlanEligibilityRequest);
/**
 * SOURCE RetrievePlanEligibilityResponse @ squareup/capital/servicing/plan/service.proto at 134:1
 */
export const RetrievePlanEligibilityResponse = $root.lookupType('squareup.capital.servicing.plan.service.RetrievePlanEligibilityResponse');
fixType(RetrievePlanEligibilityResponse);
Builder.createAndAttachToType(RetrievePlanEligibilityResponse);
/**
 * SOURCE GetPlanOriginationStatusRequest @ squareup/capital/servicing/plan/service.proto at 142:1
 */
export const GetPlanOriginationStatusRequest = $root.lookupType('squareup.capital.servicing.plan.service.GetPlanOriginationStatusRequest');
fixType(GetPlanOriginationStatusRequest, {
  planToken: {
    required: true
  }
});
Builder.createAndAttachToType(GetPlanOriginationStatusRequest);
/**
 * SOURCE GetPlanOriginationStatusResponse @ squareup/capital/servicing/plan/service.proto at 147:1
 */
export const GetPlanOriginationStatusResponse = $root.lookupType('squareup.capital.servicing.plan.service.GetPlanOriginationStatusResponse');
fixType(GetPlanOriginationStatusResponse);
Builder.createAndAttachToType(GetPlanOriginationStatusResponse);
/**
 * SOURCE GetPlanLinkedBankAccountRequest @ squareup/capital/servicing/plan/service.proto at 153:1
 */
export const GetPlanLinkedBankAccountRequest = $root.lookupType('squareup.capital.servicing.plan.service.GetPlanLinkedBankAccountRequest');
fixType(GetPlanLinkedBankAccountRequest, {
  planToken: {
    required: true
  }
});
Builder.createAndAttachToType(GetPlanLinkedBankAccountRequest);
/**
 * SOURCE GetPlanLinkedBankAccountResponse @ squareup/capital/servicing/plan/service.proto at 158:1
 */
export const GetPlanLinkedBankAccountResponse = $root.lookupType('squareup.capital.servicing.plan.service.GetPlanLinkedBankAccountResponse');
fixType(GetPlanLinkedBankAccountResponse);
Builder.createAndAttachToType(GetPlanLinkedBankAccountResponse);
/**
 * SOURCE PlanService @ squareup/capital/servicing/plan/service.proto at 14:1
 */
export const PlanService = $root.lookupService('squareup.capital.servicing.plan.service.PlanService');